var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.49 700.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b068;\n      }\n      .skin-dark {\n        fill: #d8aa88;\n      }\n      .skin {\n        fill: #ecbc94;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.76,701H15.41C40.46,575.15,147.65,480.59,276.09,480.59S511.71,575.15,536.76,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin-dark",
    d: "M289.87,585H261.06c-38.41,0-68.18-29.07-63.59-62.08L203.72,478H347.21l6.25,44.92C358.05,555.93,328.28,585,289.87,585Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M504,264.51c0,71.6-42.25,144.75-98.16,192.37C372.27,485.45,325.76,499.6,303,513.39a52.74,52.74,0,0,1-54.59,0c-24.9-15.11-78-32.57-114.55-65.17C81.49,401.49,47.51,332,47.51,264.51c0-72.63.34-158,41.23-205.84C130.1,10.33,212.36,0,275.75,0c61.51,0,143,10.89,184.06,56.75C502.87,104.86,504,189.72,504,264.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M94.37,232.07A48.4,48.4,0,0,1,85,300.83c-12.25,9.18-38.49,9.63-59.3,8.24C9.1,308-2.71,292.82.54,276.82c4.08-20.05,11.39-44.74,23.64-53.92C46.15,206.44,77.57,210.55,94.37,232.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M459.12,231.23A48.4,48.4,0,0,0,468.48,300c12.25,9.18,38.49,9.63,59.3,8.24C544.39,307.11,556.2,292,553,276c-4.08-20.05-11.4-44.74-23.64-53.92C507.34,205.6,475.92,209.71,459.12,231.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset10);
export default __webpack_public_path__ + "static/media/Asset 10.9f9352bb.svg";
export { ForwardRef as ReactComponent };